export enum USER_ROLE {
  CUSTOMER = 'CUSTOMER',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  USER_LITE = 'USER_LITE',
  USER_LITE_PLUS = 'USER_LITE_PLUS',
}
